var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAmiodarona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7224 10.3742L30.7765 7.3202C31.2075 6.8892 31.9076 6.8892 32.3387 7.3202C32.7716 7.75314 32.7716 8.45132 32.3387 8.88426L29.2845 11.9383",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7224 10.3742L30.7765 7.3202C31.2075 6.8892 31.9076 6.8892 32.3387 7.3202C32.7716 7.75314 32.7716 8.45132 32.3387 8.88426L29.2845 11.9383",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5248 11.794C35.1698 12.1489 34.5926 12.1489 34.2376 11.794L27.9968 5.55334C27.6419 5.1984 27.6419 4.62309 27.9968 4.2662C28.3517 3.91127 28.929 3.91127 29.2859 4.2662L35.5267 10.5069C35.8817 10.8618 35.8817 11.4371 35.5267 11.794H35.5248Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77989 31.2006L3.98224 36",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95871 33.9971L13.7573 33.2541L6.74223 26.0871L5.98553 33.024L6.95871 33.9971Z",
    fill: "white",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6861 32.7295C13.3755 34.04 10.649 33.4355 8.59346 31.3819C6.53984 29.3283 5.9372 26.6019 7.24778 25.2914L22.6372 9.9023C23.9478 8.59176 26.6743 9.19438 28.7279 11.2479C30.7815 13.3015 31.3841 16.0279 30.0736 17.3384L14.6841 32.7275L14.6861 32.7295Z",
    fill: "#F5FBFA",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9645 17.7557L25.0415 15.8328",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0402 19.6807L23.8934 18.5339",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9562 21.7635L21.0333 19.8406",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0336 23.6883L19.8868 22.5416",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 25.4182L17.377 23.4953",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.379 27.343L16.2322 26.1963",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6227 28.7297L13.6978 26.8048",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6981 30.6525L12.5513 29.5057",
    stroke: "#228C80",
    strokeWidth: 0.996568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAmiodarona);
export default __webpack_public_path__ + "static/media/Ic_amiodarona.e52aa9a2e3b44dec31685363ee146850.svg";
export { ForwardRef as ReactComponent };